import React, { useEffect } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Tabs } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

function Statistics() {
  const { TabPane } = Tabs;

  return (
    <Dashboard title="Dashboard">
      <div className="d-flex justify-content-between">
        <div></div>
        <div className="filter-icon">
          <i className="p-2 border border-2 rounded fas fa-filter cursor-pointer"></i>
        </div>
      </div>
      <Tabs
        defaultActiveKey="1"
        type="card"
        className="dash"
        style={{ marginTop: -40 }}
      >
        <TabPane tab="Analytics" key="1">
          <div className="row">
            <div className="col-md-3 col-sm-12">
              <div className="card p-3 rounded-0 dash-card shadow-sm m-1">
                <div className="card-data">
                  <p className="m-0 fw-bold">Pending Application</p>
                  <h2>317</h2>
                </div>
                <div className="mr-2">
                  <i className="fa fa-file-text-o"></i>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <div className="card p-3 rounded-0 dash-card shadow-sm m-1">
                <div className="card-data">
                  <p className="m-0">Job Offered</p>
                  <h2>52</h2>
                  <span>in 24 hours no update</span>
                </div>
                <div className="mr-2">
                  <i className="far fa-handshake"></i>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <div className="card p-3 rounded-0 dash-card shadow-sm m-1">
                <div className="card-data">
                  <p className="m-0">Final Interview</p>
                  <h2>15</h2>
                  <span>in 24 hours no update</span>
                </div>
                <div className="mr-2">
                  {/* <i className="fa fa-user"></i> */}
                  <CheckCircleOutlined className="dash-tick-icon" />
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <div className="card p-3 rounded-0 dash-card shadow-sm m-1">
                <div className="card-data">
                  <p className="m-0">New Requisition</p>
                  <h2>7</h2>
                </div>
                <div className="mr-2">
                  <i className="fab fa-battle-net"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-lg-3 mt-1">
            <div className="col-md-3">
              <div className="card p-3 rounded-0 shadow-sm m-1 img-card">
                <p className="m-0">Current Interview Status</p>
                <img
                  src="https://lh3.googleusercontent.com/g0Jw-I6-gH2DVCpnl3u8QKZVT_meR9lcJlpyeSZ-MyvwLnyEZvgyrY5frldA8HCv55s=w280-rwa"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="card p-3 rounded-0 shadow-sm m-1 img-card">
                <p className="m-0">Locationwise Data</p>
                <img
                  src="https://lh3.googleusercontent.com/g0Jw-I6-gH2DVCpnl3u8QKZVT_meR9lcJlpyeSZ-MyvwLnyEZvgyrY5frldA8HCv55s=w280-rwa"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="card p-3 rounded-0 shadow-sm m-1 img-card">
                <p className="m-0">Departmentwise Count</p>
                <img
                  src="https://lh3.googleusercontent.com/g0Jw-I6-gH2DVCpnl3u8QKZVT_meR9lcJlpyeSZ-MyvwLnyEZvgyrY5frldA8HCv55s=w280-rwa"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="card p-3 rounded-0 shadow-sm m-1 img-card">
                <p className="m-0">Data Source</p>
                <img
                  src="https://lh3.googleusercontent.com/g0Jw-I6-gH2DVCpnl3u8QKZVT_meR9lcJlpyeSZ-MyvwLnyEZvgyrY5frldA8HCv55s=w280-rwa"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="row mt-lg-3 mt-1">
            <div className="col">
              <div className="card p-3 rounded-0 shadow-sm m-1 img-long">
                <p className="m-0">Last 10 Days Status</p>
                <img
                  src="https://images.squarespace-cdn.com/content/v1/5419dceee4b06e634ce29c26/1537463202581-ZHS9SX5JRLOIKX9VT13O/1-multi-series-bar-chart-800w-opt.png?format=1500w"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="row mt-lg-3 mt-1">
            <div className="col-md-6">
              <div className="card p-3 rounded-0 shadow-sm m-1 img-card">
                <p className="m-0">Gender Ratio</p>
                <img
                  src="https://www.thinkoutsidetheslide.com/wp-content/uploads/2019/09/Default-bar-order-bar-chart.jpg"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="card p-3 rounded-0 shadow-sm m-1 img-card">
                <p className="m-0">Qualification wise Data</p>
                <img
                  src="https://chartio.com/assets/24e451/tutorials/charts/grouped-bar-charts/c1fde6017511bbef7ba9bb245a113c07f8ff32173a7c0d742a4e1eac1930a3c5/grouped-bar-example-1.png"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane tab="Kanban" key="2">
          Content of card tab 2
        </TabPane>
      </Tabs>
    </Dashboard>
  );
}

export default Statistics;
